import { useEffect } from "react";
import throttle from "lodash-es/throttle";
import getUndef from "../../lib/get-undef";

const useCatalogScroll = (code: string) => {
  useEffect(() => {
    const prevPos = getUndef(() => +sessionStorage.getItem(`scroll_${code}`));
    if (prevPos !== undefined) {
      setTimeout(() => {
        window.scrollTo(0, prevPos);
      }, 0);
    }

    const throttledHandleScroll = throttle(handleScroll.bind(null, code), 100);
    window.addEventListener("scroll", throttledHandleScroll);
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
    };
  }, [code]);
};

function handleScroll(code: string, e: any) {
  try {
    sessionStorage.setItem(`scroll_${code}`, String(window.scrollY));
  } catch (error) {
    console.error(error);
  }
}

export default useCatalogScroll;
